export const longPollingActiveRequestsLSKey = "activeRequests";
export const lastSelectedUserLangLSKey = "lastSelectedLang";
